import colourPaletteCatalog from './colourPaletteCatalog.json';

// The 71 fixed swatches mirror the backend's colour_palette_catalog.py.
// The catalogue, rather than a saved model response, defines their screen hues.
const FIXED_SWATCHES = new Map(Object.entries(colourPaletteCatalog)
  .map(([name, hex]) => [name.trim().toLowerCase(), hex]));

// Approximate screen illustrations of older free-form names returned by the analyser.
// Match specific names before broad hue families so, for example, brick red
// does not inherit the brighter generic red swatch.
const SWATCHES = [
  [/\b(?:soft )?ivory\b|\bcream\b/i, '#EDE1C9'],
  [/\boatmeal\b/i, '#D7C8AD'],
  [/\b(?:light|pale)\s+warm\s+beige\b/i, '#D8C0A3'],
  [/\bbeige\b/i, '#CDB799'],
  [/\b(?:light|pale)\s+taupe\b/i, '#B5A6A0'],
  [/\btaupe\b|\bmushroom\b/i, '#9F8E89'],
  [/\bsand\b/i, '#D9C6A6'],
  [/\b(?:gentle|soft|light|pale)\s+stone\b|\bstone\b/i, '#B8AEA3'],
  [/\bwhite\b/i, '#F4F1EB'], [/\bblack\b/i, '#29282B'],
  [/\bespresso\b|\bchocolate\b|\bcoffee\b/i, '#4D332E'],
  [/\b(?:soft|light)\s+cocoa\b/i, '#927367'],
  [/\bcocoa\b/i, '#75564A'],
  [/\brosewood\b/i, '#8F6665'],
  [/\bmahogany\b|\bchestnut\b/i, '#70473D'],
  [/\b(?:light|pale)\s+camel\b/i, '#C7A27E'],
  [/\bcamel\b|\btan\b/i, '#B8875D'],
  [/\b(?:soft|light|muted)\s+blue[ -]grey\b/i, '#7D8C91'],
  [/\b(?:light|pale)\s+warm\s+(?:grey|gray)\b/i, '#B9B1AA'],
  [/\bcharcoal\b|\bgrey\b|\bgray\b/i, '#62636A'],
  [/\bnavy\b|\bindigo\b/i, '#334561'],
  [/\b(?:soft|muted|smoky)\s+russet\b/i, '#AB725F'],
  [/\bbrick\b|\brust\b|\brusset\b|\bterracotta\b|\bclay\b/i, '#B7664E'],
  [/\boxblood\b/i, '#713C43'],
  [/\bberry\b|\bburgundy\b|\bwine\b/i, '#7D4054'],
  [/\bmauve\b|\bdusty rose\b/i, '#AD7D91'],
  [/\brose\b|\bblush\b/i, '#C88798'],
  [/\b(?:light|pale|soft)\s+salmon\b/i, '#E4A695'],
  [/\bsalmon\b/i, '#D78578'],
  [/\bpeach\b|\bapricot\b/i, '#E5A079'],
  [/\bpink\b|\bcoral\b/i, '#DC8191'],
  [/\bred\b|\btomato\b/i, '#B9484C'],
  [/\bolive\b|\bsage\b/i, '#858C64'],
  [/\b(?:smoky|soft|muted)\s+pine\b/i, '#5A746A'],
  [/\bpine\b|\bforest\b|\bmoss\b/i, '#456F5E'],
  [/\beucalyptus\b/i, '#799889'],
  [/\b(?:light|soft|fresh)\s+(?:soft\s+)?green\b/i, '#88B58B'],
  [/\bmint\b/i, '#AFD5B8'],
  [/\bemerald\b|\bgreen\b/i, '#397962'],
  [/\bteal\b|\bpetrol\b|\bpeacock\b/i, '#347D80'],
  [/\baqua\b|\bturquoise\b/i, '#75AFB4'],
  [/\bblue\b/i, '#5C87AE'],
  [/\blavender\b|\blilac\b/i, '#B4A1C6'],
  [/\baubergine\b|\bplum\b|\bpurple\b|\borchid\b/i, '#775579'],
];

export function swatchFor(name) {
  return SWATCHES.find(([pattern]) => pattern.test(name))?.[1] || null;
}

// The report may have been saved before the fixed palette catalogue was added.
// A saved swatch is useful only when its colour and label still match the name
// displayed to the user. Invalid CSS colours otherwise leave a blank tile.
export function displaySwatchFor(name, savedSwatch) {
  const normalizedName = String(name).trim().toLowerCase();
  const fixed = FIXED_SWATCHES.get(normalizedName);
  if (fixed) return fixed;
  const namedFallback = swatchFor(name);
  if (namedFallback) return namedFallback;
  const hex = savedSwatch?.hex;
  const sameName = typeof savedSwatch?.name === 'string'
    && savedSwatch.name.trim().toLowerCase() === normalizedName;
  if (sameName && typeof hex === 'string' && /^#[0-9a-f]{6}$/i.test(hex)) return hex;
  return '#B8AEA3';
}
